import { useForm } from 'react-hook-form';
import { dataToForm, RealEstateFormValues, UpsertIncomeDTO } from './RealEstateForm.meta';
import { IncomeDTO, IncomeModel, IncomeType } from "../../api/useIncomeQuery";
import { useUpsertIncomeMutation } from '../../api/useUpsertIncomeMutation';
import { toast } from '../../../../CommonComponents/OPL/Toast/Toast';
import { ADD_INCOME_SUCCESS_MESSAGE, EDIT_INCOME_SUCCESS_MESSAGE } from '../../Income.meta';

const FIELDS_TO_SHOW_ADVANCED = ['IncomeGrowth', 'YearlyTaxableAmount'];

interface Params {
  clientId: string;
  income: IncomeModel | null;
  onSuccess: () => void;
  data: IncomeDTO;
}

export const useRealEstateForm = ({ clientId, income, onSuccess, data }: Params) => {
  const formBag = useForm<RealEstateFormValues>({
    defaultValues: dataToForm(income, data),
  });

  const [managementStyleValue, customBucketIndex] = formBag.watch([
    'orionManagementStyleId',
    'customBucketIndex',
  ]);

  const mutationBag = useUpsertIncomeMutation({ clientId });

  const defaultShowAdvanced =
    !!income && FIELDS_TO_SHOW_ADVANCED.some(field => !!income[field] || income[field] === 0);

  const onSubmit = formBag.handleSubmit(async (values: RealEstateFormValues) => {
    const body: UpsertIncomeDTO = {
      clientId,
      ...values,
      id: income?.Id || null,
      incomeType: IncomeType.RealEstate,
    };

    try {
      await mutationBag.mutateAsync(body);

      toast.success(income?.Id ? EDIT_INCOME_SUCCESS_MESSAGE : ADD_INCOME_SUCCESS_MESSAGE);

      onSuccess();
    } catch (error) {
      console.error(error);
    }
  });

  return {
    data: {
      formBag,
      defaultShowAdvanced,
      mutationBag,
      managementStyleValue,
      customBucketIndex,
    },
    actions: {
      onSubmit,
    },
  };
};
